import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';

class SalesReportDataTableZFM extends Component {

  // constructor(props) {
  //   super(props);
  // }


  render() {

    const rowsList = (this.props.fleetSales || []).map(f =>
      <tr className={f.business_name === 'Total' ? "zfm-table-bg-orange sales-report-th" : ''}>
        {/* <td onClick={(e) => this.props.goToMemberSalesReport({ uuid: f.user_id, owner_name: f.owner_name, member_id: f.member_id, region_name: f.region_name })} className="capital-case sales-report-td" style={{ color: '#545cd8', cursor: 'pointer' }}>{f.owner_name}</td> */}
        <td style={f.business_name === 'Total' ? { fontWeight: 'bold' } : {}} className="zfm-table-value">{f.business_name}<br />
          {f.business_name === 'Total' ?
            <span className="zfm-table-value" style={{ textTransform: 'capitalize' }}>{f.region_name} </span> :
            <span className="zfm-table-value" style={{ textTransform: 'capitalize' }}>{f.region_name} ({f.area_name}) </span>
          }
        </td>
        <td style={f.business_name === 'Total' ? { fontWeight: 'bold' } : {}} className="zfm-table-value">{f.tbr_direct_sales}</td>
        <td style={f.business_name === 'Total' ? { fontWeight: 'bold' } : {}} className="zfm-table-value">{f.tbr_direct_achievement}</td>
        {/* <td style={f.business_name == 'Total' ? {fontWeight:'bold'} : {}} className="zfm-table-value">{f.tbr_indirect_sales}</td>
        <td style={f.business_name == 'Total' ? {fontWeight:'bold'} : {}} className="zfm-table-value">{f.tbr_indirect_achievement}</td> */}
        {/* <td style={f.business_name == 'Total' ? {fontWeight:'bold'} : {}} className="zfm-table-value">{f.tbr_total_achievement}</td> */}
        <td style={f.business_name === 'Total' ? { fontWeight: 'bold' } : {}} className="zfm-table-value">{f.tbr_percent}</td>
        <td style={f.business_name === 'Total' ? { fontWeight: 'bold' } : {}} className="zfm-table-value">{f.tbb_direct_sales}</td>
        <td style={f.business_name === 'Total' ? { fontWeight: 'bold' } : {}} className="zfm-table-value">{f.tbb_direct_achievement}</td>
        {/* <td style={f.business_name == 'Total' ? {fontWeight:'bold'} : {}} className="zfm-table-value">{f.tbb_indirect_sales}</td>
        <td style={f.business_name == 'Total' ? {fontWeight:'bold'} : {}} className="zfm-table-value">{f.tbb_indirect_achievement}</td> */}
        {/* <td style={f.business_name == 'Total' ? {fontWeight:'bold'} : {}} className="zfm-table-value">{f.tbb_total_achievement}</td> */}
        <td style={f.business_name === 'Total' ? { fontWeight: 'bold' } : {}} className="zfm-table-value">{f.tbb_percent}</td>
        <td style={f.business_name === 'Total' ? { fontWeight: 'bold' } : {}} className="zfm-table-value">{f.total_direct_target}</td>
        <td style={f.business_name === 'Total' ? { fontWeight: 'bold' } : {}} className="zfm-table-value">{f.total_direct_achievement}</td>
        {/* <td style={f.business_name == 'Total' ? {fontWeight:'bold'} : {}} className="zfm-table-value">{f.total_indirect_target}</td>
        <td style={f.business_name == 'Total' ? {fontWeight:'bold'} : {}} className="zfm-table-value">{f.total_indirect_achievement}</td> */}
        {/* <td style={f.business_name == 'Total' ? {fontWeight:'bold'} : {}} className="zfm-table-value">{f.total_sales}</td>
        <td style={f.business_name == 'Total' ? {fontWeight:'bold'} : {}} className="zfm-table-value">{f.total_achievement}</td> */}
        {/* <td className="zfm-table-value">{f.total_percent}</td> */}
      </tr>);

    return (
      <div>
        {this.props.fleetSales && this.props.fleetSales.length > 0 && <Row>
          <Col>
            <span className="Download-Full-Report pull-right" onClick={this.props.downloadReport} style={{ cursor: 'pointer' }}>Download Full Report</span>
          </Col>
        </Row>}
        <Card className="c-top-15">
          <CardBody>
            <table className="table table-bordered table-responsive">
              <thead style={{ background: '#f6f6f6' }}>
                <tr>
                  <th />
                  {/* <th className="sales-report-th">FM Name & Location</th> */}
                  <th colSpan="3" className="sales-report-th text-align-center">TBR</th>
                  <th colSpan="3" className="sales-report-th text-align-center">TBB</th>
                  <th colSpan="2" className="sales-report-th text-align-center">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowSpan="3" className="zfm-table-bg-grey text-align-center">
                    <div>FM Name & Location</div>
                    <div>[Region (Area)]</div>
                  </td>
                  <td colSpan="2" className="sales-report-th text-align-center">Target</td>
                  {/* <td rowSpan="3" className="zfm-table-bg-orange sales-report-th">Total Sales</td> */}
                  <td rowSpan="3" className="sales-report-th">% Achv</td>
                  <td colSpan="2" className="sales-report-th text-align-center">Target</td>
                  {/* <td rowSpan="3" className="zfm-table-bg-orange sales-report-th">Total Sales</td> */}
                  <td rowSpan="3" className="sales-report-th">% Achv</td>
                  <td rowSpan="2" colSpan="2" className="sales-report-th text-align-center">Direct<br />(TBB + TBR)</td>
                  {/* <td rowSpan="2" colSpan="2" className="sales-report-th text-align-center">Indirect<br/>(TBB + TBR)</td> */}
                  {/* <td rowSpan="2" colSpan="2" className="sales-report-th text-align-center">Total<br/>(TBB + TBR)</td> */}
                  {/* <td rowSpan="3" className="sales-report-th">Target</td>
                  <td rowSpan="3" className="sales-report-th">Achievement</td>
                  <td rowSpan="3" className="sales-report-th">% Achievement</td> */}
                </tr>
                <tr>
                  {/* <td /> */}
                  <td colSpan="2" className="zfm-table-bg-grey zfm-table-value text-align-center">Direct</td>
                  {/* <td colSpan="2" className="zfm-table-bg-grey zfm-table-value text-align-center">Indirect</td> */}
                  <td colSpan="2" className="zfm-table-bg-grey zfm-table-value text-align-center">Direct</td>
                  {/* <td colSpan="2" className="zfm-table-bg-grey zfm-table-value text-align-center">Indirect</td> */}
                  {/* <td rowSpan="2" className="zfm-table-bg-grey zfm-table-value text-align-center">Target</td>
                  <td rowSpan="2" className="zfm-table-bg-grey zfm-table-value text-align-center">Achv.</td>
                  <td rowSpan="2" className="zfm-table-bg-grey zfm-table-value text-align-center">Target</td>
                  <td rowSpan="2" className="zfm-table-bg-grey zfm-table-value text-align-center">Achv.</td>
                  <td rowSpan="2" className="zfm-table-bg-grey zfm-table-value text-align-center">Target</td>
                  <td rowSpan="2" className="zfm-table-bg-grey zfm-table-value text-align-center">Achv.</td> */}
                </tr>
                <tr>
                  {/* <td /> */}
                  <td className="zfm-table-value">Target</td>
                  <td className="zfm-table-value">Achv.</td>
                  {/* <td className="zfm-table-value">Target</td>
                  <td className="zfm-table-value">Achv.</td> */}
                  <td className="zfm-table-value">Target</td>
                  <td className="zfm-table-value">Achv.</td>
                  {/* <td className="zfm-table-value">Target</td>
                  <td className="zfm-table-value">Achv.</td> */}
                  <td className="zfm-table-value">Target</td>
                  <td className="zfm-table-value">Achv.</td>
                  {/* <td className="zfm-table-value">Target</td>
                  <td className="zfm-table-value">Achv.</td> */}
                  {/* <td className="zfm-table-value">Target</td>
                  <td className="zfm-table-value">Achv.</td> */}
                </tr>
                {rowsList}
              </tbody>
            </table>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default SalesReportDataTableZFM;